// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.4dbedb1b6.chunk.js";
	if (chunkId === 12) return "static/js/profiler.4dbedb1b6.chunk.js";
	if (chunkId === 524) return "static/js/524.4dbedb1b6.chunk.js";
	if (chunkId === 625) return "static/js/625.4dbedb1b6.chunk.js";
	if (chunkId === 160) return "static/js/160.4dbedb1b6.chunk.js";
	if (chunkId === 103) return "static/js/103.4dbedb1b6.chunk.js";
	if (chunkId === 177) return "static/js/177.4dbedb1b6.chunk.js";
	// return url for filenames based on template
	return undefined;
};